const sizes = {
  xs: '20.5rem',
  sm: '31.5rem',
  md: '42.5rem',
  lg: '53.5rem',
};
export type SizeValue = keyof typeof sizes;

const styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    padding: '0.5rem 0 !important',
  },
  dialogPaper: (width: SizeValue) => ({ padding: '1.5rem', width: sizes[width] }),
};

export default styles;
